import script from "./TechSupportManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./TechSupportManagement.vue?vue&type=script&setup=true&lang=js"

import "./TechSupportManagement.vue?vue&type=style&index=0&id=88644eae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88644eae"]])

export default __exports__